"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = PageHeader;
var _react = _interopRequireDefault(require("react"));
var _Title = require("../../Elements/Title/Title");
var _classnames = _interopRequireDefault(require("classnames"));
var _jsxRuntime = require("react/jsx-runtime");
function PageHeader({
  title: {
    content: titleText,
    tag: titleTag = 'h1',
    ...titleProps
  },
  subtitle,
  className
}) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
    className: (0, _classnames.default)('ccl__page-header', className || ''),
    children: [subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
      className: "ccl__page-header__subtitle",
      size: "heading-6",
      tag: "h2",
      content: subtitle
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
      className: "ccl__page-header__title",
      tag: titleTag,
      content: titleText,
      ...titleProps
    })]
  });
}
module.exports = exports.default;